import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "type",
  "use": "type-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"type\">\n<path d=\"M20,8c-0.6,0-1-0.4-1-1V5H5v2c0,0.6-0.4,1-1,1S3,7.6,3,7V4c0-0.6,0.4-1,1-1h16c0.6,0,1,0.4,1,1v3C21,7.6,20.6,8,20,8z\" />\n<path d=\"M15,21H9c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S15.6,21,15,21z\" />\n<path d=\"M12,21c-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1s1,0.4,1,1v16C13,20.6,12.6,21,12,21z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol